"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencyUtil = void 0;
const CURRENCY_TRADITIONAL_RANKINGS = ['EUR', 'GBP', 'AUD', 'NZD', 'USD', 'CAD', 'CHF', 'JPY'];
class CurrencyUtil {
    static round(n, d) {
        return this.roundAndScale(n, d, 1.0);
    }
    static roundAndScale(n, d, scaleFactor) {
        n = n / scaleFactor;
        const scale = Math.pow(10, d);
        return Math.round(n * scale) / scale;
    }
    static currencyScalePower(ccy) {
        // if (ccy === 'INR') {
        //     return 1_000_000_000;
        // }
        return 1000000;
    }
    static currencyRounding(ccy) {
        return 2;
    }
    static isFXQuoteConvention(firstCcy, secondCcy) {
        const firstIndex = CURRENCY_TRADITIONAL_RANKINGS.indexOf(firstCcy);
        const secondIndex = CURRENCY_TRADITIONAL_RANKINGS.indexOf(secondCcy);
        if (firstIndex === secondIndex) {
            return true; // Even though its ambiguous... we've been asked about a strange cross pair
        }
        if (firstIndex === -1) {
            return false;
        }
        return firstIndex <= secondIndex;
    }
}
exports.CurrencyUtil = CurrencyUtil;
CurrencyUtil.CURRENCIES = ['AUD', 'BRL', 'CAD', 'CHF', 'CNY', 'DKK', 'EUR', 'GBP', 'HKD', 'INR', 'JPY', 'KRW', 'MXN', 'MYR', 'NOK', 'NZD', 'PLN', 'RUB', 'SEK', 'SGD', 'THB', 'TRY', 'TWD', 'USD', 'ZAR',];
//# sourceMappingURL=currency-util.js.map